/**
 * Agrupación visual de las líneas de pack (packOrigin): cada regalo generado por
 * el servidor se pinta inmediatamente debajo de la línea de su producto padre.
 * Los regalos cuyo padre no está en la lista (p. ej. el padre quedó obsoleto y
 * vive en la otra sección) se dejan al final para no perderlos de vista.
 */
export const groupPackLines = (products = []) => {
  const packLines = products.filter((product) => product.packOrigin);
  if (packLines.length === 0) return products;
  const rest = products.filter((product) => !product.packOrigin);
  const grouped = [];
  rest.forEach((product) => {
    grouped.push(product);
    packLines
      .filter((packLine) => packLine.packParentId === product.id)
      .forEach((packLine) => grouped.push(packLine));
  });
  packLines
    .filter((packLine) => !rest.some((product) => product.id === packLine.packParentId))
    .forEach((packLine) => grouped.push(packLine));
  return grouped;
};

/** Nombre del producto padre de una línea de pack, para el "Incluido con …". */
export const packParentName = (products = [], packLine) =>
  products.find((product) => !product.packOrigin && product.id === packLine.packParentId)?.name;
